import {IError} from '../../types/interface/Assurance/assuranceRetraite';
import {dataOption} from '../../types/interface/input';

export const showErrorValuesDefault = {
  nomPrenomContractant: false,
  dateNaissanceContractant: false,
  cinContractant: false,
  telephoneContractant: false,
  nomPrenomAssure: false,
  dateNaissanceAssure: false,
  adresseAssure: false,
  telephoneAssure: false,
  emailAssure: false,
  agence: false,
  premierVersement: false,
  beneficiaireCasDeces: false,
  cinAssure: false,
};
export const showErrorValuesSubmit = {
  nomPrenomContractant: true,
  dateNaissanceContractant: true,
  cinContractant: true,
  telephoneContractant: true,
  nomPrenomAssure: true,
  dateNaissanceAssure: true,
  adresseAssure: true,
  telephoneAssure: true,
  emailAssure: true,
  agence: true,
  premierVersement: true,
  beneficiaireCasDeces: true,
  cinAssure: true,
};

export const defaultValues: IError = {
  nomPrenomContractant: '',
  dateNaissanceContractant: '',
  cinContractant: [],
  telephoneContractant: '',
  telephoneContractantCountryCode: '',
  nomPrenomAssure: '',
  dateNaissanceAssure: '',
  adresseAssure: '',
  telephoneAssure: '',
  telephoneAssureCountryCode: '',
  emailAssure: '',
  agence: '',
  premierVersement: '',
  beneficiaireCasDeces: '',
  cinAssure: [],
};

export const TitleLabels = {
  contractant: {
    nomPrenomContractant: 'Nom et prénom(s) du Contractant',
    dateNaissanceContractant: 'Date de naissance du Contractant ',
    cinContractant: 'Joindre CIN du Contractant',
    telephoneContractant: 'Téléphone du Contractant',
    emailContractant: 'Email Contractant',
    agence: 'Agence ARO (gestionaire du contrat)',
    premierVersement: 'Premier versement (Cotisation)',
    beneficiaireCasDeces: 'Nom du bénéficiaire en cas de décès',
  },
  assure: {
    nomPrenomAssure: "Nom et prénom(s) de l'Assuré ",
    dateNaissanceAssure: "Date de naissance de l'Assuré",
    adresseAssure: "Adresse de l'Assuré ",
    telephoneAssure: "Téléphone de l'Assuré ",
    emailAssure: "Email de l'Assuré",
    cinAssure: "Joindre CIN de l'assuré",
  },
};

export const frequenceOptions: dataOption[] = [
  {
    label: 'Tous les mois',
    value: 'Tous les mois',
  },
  {
    label: 'Tous les ans',
    value: 'Tous les ans',
  },
  {
    label: 'Une seule fois',
    value: 'Une seule fois',
  },
];

export const defaultDevisValues = {
  DateNaissance: '',
  Cotisation: '',
  ModeVersement: 'Tous les mois',
};

export const defaultValuesPension = {
  DateNaissance: '',
  Pension: '',
  ModeVersement: 'Tous les mois',
};

export const defaultValuesCapital = {
  DateNaissance: '',
  Capital: '',
  ModeVersement: 'Tous les mois',
};

export const capitalSecondary =
  "Le montant de la cotisation à verser pour toucher le Capital Retraite souhaité à 60 ans sans tenir compte d'éventuelles participations aux bénéfices";

export const capitalPrimary =
  "Si vous optez pour le versement d'une rente trimestrielle au lieu du Capital Retraite";

export const cotisationSecondary =
  "La Rente trimestrielle que vous toucheriez à 60 ans est calculée sans tenir compte d'éventuelles participations aux bénéfices";

export const cotisationPrimary =
  "Si vous optez pour le versement d'un Capital Retraite sans tenir compte d'éventuelles participations aux bénéfices au lieu de la rente trimestrielle";

export const pensionSecondary =
  "Le montant de la cotisations à verser pour toucher la Rente trimestrielle souhaitée à 60 ans sans tenir compte d'éventuelles participations aux bénéfices";

export const pensionPrimary =
  "Si vous optez pour le versement d'un Capital Retraite au lieu de la Rente trimestrielle";

export const MIN_COTISATION = 2000;
